var __rspack_ns_object = {"rE":"0.0.93"}